export const COMMUNITY_NAME_MAX_LENGTH = 64

export const DESCRIPTION_MAX_LENGTH = 200
